import {questions} from '@components/competitions/levels/muharram/assets/questions';
import {useCompetitionMuharramContext} from '@context/CompetitionMuharramContext';
import {FormControl, FormControlLabel, Radio, RadioGroup, Typography} from '@mui/material';

export const DayQuizWrapper = ({dayId}: {dayId: number}) => {
	const {answers, setAnswers} = useCompetitionMuharramContext();
	const dayQuestions = questions[dayId] || [];
	
	const selectedAnswers = answers[dayId] || {};
	
	const handleAnswerChange = (questionIndex: number, selectedAnswerValue: string) => {
		const selectedAnswerIndex = parseInt(selectedAnswerValue);
		
		const updatedDayAnswers = {
			...selectedAnswers,
			[questionIndex]: selectedAnswerIndex
		};
		
		const updatedAnswers = {
			...answers,
			[dayId]: updatedDayAnswers
		};
		
		setAnswers(updatedAnswers);
		localStorage.setItem('muharram_answers', JSON.stringify(updatedAnswers));
	};
	
	const titleImageSrc = `/images/muharram/d${dayId}-title.webp`;
	
	return (
		<div className="p-4">
			<img
				src={titleImageSrc}
				alt={`Day ${dayId} Title`}
				className="w-full h-auto object-contain mb-10"
			/>
			{dayQuestions.map((q, index) => (
				<FormControl component="fieldset" key={index} className="mb-6">
					<Typography className="text-white font-bold mb-2">{q.question}</Typography>
					<RadioGroup
						name={`question-${index}`}
						value={selectedAnswers[index] ?? ''}
						onChange={(e) => handleAnswerChange(index, e.target.value)}
						className="flex flex-col gap-y-2"
					>
						{q.answers.map((answer, i) => (
							<FormControlLabel
								key={i}
								value={i.toString()}
								control={
									<Radio
										sx={{
											transform: 'scale(0.8)',
											color: '#004038',
											'&.Mui-checked': {
												color: '#fff'
											}
										}}
									/>
								}
								label={<Typography className="text-sm text-white">{answer}</Typography>}
								className="pr-2 rounded-md transition flex flex-row h-8"
							/>
						))}
					</RadioGroup>
				</FormControl>
			))}
		</div>
	);
};
